import { Address, DeliveryEstimate } from 'olo-service';
import { useColoResource } from './useColoResource';

export function useDeliveriesEstimate(merchantId?: string, address?: Address, deliveryTime?: number) {
  const { address1, address2, city, country, state, zip } = address || {};
  const [isDeliveriesEstimateLoading, estimations, error] = useColoResource<DeliveryEstimate>(() => merchantId && address && ({
    method: 'POST',
    url: `${merchantId}/deliveries/estimate`,
    data: {
      address: { address1, address2, city, country, state, zip },
      deliveryTime
    }
  }), [deliveryTime, address1, address2, city, country, state, zip, deliveryTime, merchantId]);

  return { isDeliveriesEstimateLoading, estimations, error };
}
